/*
 * Filter und Optionen
 */

import {Trans} from "@lingui/macro";

export function getMattressFilters() {
    return [
        {
            id: 'firmness',
            name: <Trans>Härte</Trans>,
            options: [
                ['H2', <Trans>weich (H2)</Trans>],
                ['H3', <Trans>hart (H3)</Trans>],
                ['H3+', <Trans>sehr hart (H3+)</Trans>],
            ]
        },
        {
            id: 'washable',
            name: <Trans>Bezug waschbar</Trans>,
            options: [
                ['yes', 'ja'],
            ]
        },
        {
            id: 'flameRetardant',
            name: <Trans>Bezug flammhemmend</Trans>,
            options: [
                ['yes', 'ja'],
            ]
        },
    ]
}

export function getTopperFilters(topperFoamTypes) {
    let topperFoamTypeOptions = []
    for (const foamType in topperFoamTypes) {
        if (foamType) {
            topperFoamTypeOptions.push([foamType, foamType])
        }
    }
    return [
        {
            id: 'foamType',
            name: <Trans>Art</Trans>,
            options: topperFoamTypeOptions
        },
        {
            id: 'washable',
            name: <Trans>Bezug waschbar</Trans>,
            options: [
                ['yes', 'ja'],
            ]
        },
        {
            id: 'flameRetardant',
            name: <Trans>Bezug flammhemmend</Trans>,
            options: [
                ['yes', 'ja'],
            ]
        },
    ]
}

export function getFabricFilters(colorNames) {
    let fabricFilters = [
        {
            id: 'color',
            name: 'Farbe',
            options: colorNames
        }
    ]
    if (window.b2b) {
        fabricFilters.push(
            {
                id: 'washable',
                name: <Trans>abwaschbar</Trans>,
                options: [
                    ['yes', 'ja'],
                ]
            }
        )
        fabricFilters.push(
            {
                id: 'abrasionResistant',
                name: <Trans>strapazierfähig</Trans>,
                options: [
                    ['yes', 'ja'],
                ]
            },
        )
    }
    return fabricFilters
}

export function getBackOptions() {
    if (window.b2b) {
        return [
            {
                key: '1',
                name: <Trans>durchgehendes Rückenteil</Trans>,
            },
            {
                key: '2',
                name: <Trans>getrennte Rückenteile</Trans>,
            },
        ]
    } else {
        return null
    }
}